export const createNotifier = (emitter) => {
  const queue = [];

  const addMessage = (message) => {
    queue.push({
      message,
      key: new Date().getTime(),
    });
    emitter.emit();
  };

  const getNextMessage = () => {
    if (queue.length > 0) {
      return queue.shift();
    }

    return undefined;
  };

  const isEmpty = () => {
    if (queue.length === 0) {
      return true;
    }

    return false;
  };

  return Object.freeze({
    addMessage,
    getNextMessage,
    isEmpty,
  });
};

export default {
  createNotifier,
};
